import { faCog } from '@fortawesome/free-solid-svg-icons';
import { faSave } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PropTypes as MicromagPropTypes } from '@micromag/core';
import { Button } from '@micromag/core/components';
import { useUrlGenerator } from '@micromag/core/contexts';
import { useDocumentEvent } from '@micromag/core/hooks';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback, useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { useOrganisation } from '../../contexts/OrganisationContext';
import AddButton from '../buttons/Add';
import EditButton from '../buttons/Edit';
import PreviewButton from '../buttons/Preview';
import PublishButton from '../buttons/Publish';

// import LatestVersion from '../partials/LatestVersion';
// import TeamMembers from '../partials/TeamMembers';

const propTypes = {
    story: MicromagPropTypes.story.isRequired,
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const StoryMenubar = ({ story, className }) => {
    const url = useUrlGenerator();
    const organisation = useOrganisation();
    const { permissions: organisationPermissions = null } = organisation || {};
    const { can_publish_story: organisationCanPublishStory = false } =
        organisationPermissions || {};
    const [exportDropdownOpen, setExportDropdownOpen] = useState(false);

    const refDropdown = useRef(null);
    const onDocumentClick = useCallback(
        (e) => {
            if (refDropdown.current !== null && !refDropdown.current.contains(e.currentTarget)) {
                setExportDropdownOpen(false);
            }
        },
        [refDropdown.current, setExportDropdownOpen],
    );
    useDocumentEvent('click', onDocumentClick, exportDropdownOpen);

    return (
        <div
            className={classNames([
                'row',
                'align-items-center',
                {
                    [className]: className !== null,
                },
            ])}
        >
            <div className="col-sm">{/* <LatestVersion story={story} /> */}</div>
            <div className="col-auto mt-2 mt-sm-0">
                <div className="row">
                    <div className="col-sm">
                        <EditButton
                            href={url('stories.editor', {
                                story: story.id,
                            })}
                            theme="secondary"
                            outline
                            className="me-2 mb-2"
                        >
                            <FormattedMessage
                                defaultMessage="Edit"
                                description="Edit Button label"
                            />
                        </EditButton>
                        <PreviewButton
                            href={url('stories.preview', {
                                story: story.id,
                            })}
                            theme="secondary"
                            outline
                            className="me-2 mb-2"
                        >
                            <FormattedMessage
                                defaultMessage="Preview"
                                description="Preview Button label"
                            />
                        </PreviewButton>
                        {organisation === null || organisationCanPublishStory ? (
                            <PublishButton
                                href={url('stories.publish', {
                                    story: story.id,
                                })}
                                theme="secondary"
                                outline
                                className="me-2 mb-2"
                            >
                                <FormattedMessage
                                    defaultMessage="Publish"
                                    description="Publish Button label"
                                />
                            </PublishButton>
                        ) : null}
                        <div
                            className={classNames([
                                'dropdown',
                                'd-inline-block',
                                {
                                    show: exportDropdownOpen,
                                },
                            ])}
                            ref={exportDropdownOpen ? refDropdown : null}
                        >
                            <Button
                                href="#"
                                theme="secondary"
                                outline
                                className="me-2 mb-2 dropdown-toggle"
                                data-bs-toggle="dropdown"
                                onClick={() => setExportDropdownOpen(!exportDropdownOpen)}
                                icon={<FontAwesomeIcon icon={faSave} color="currentColor" />}
                            >
                                <FormattedMessage
                                    defaultMessage="Export"
                                    description="Button label"
                                />
                            </Button>
                            <ul
                                className={classNames([
                                    'dropdown-menu',
                                    {
                                        show: exportDropdownOpen,
                                    },
                                ])}
                            >
                                <li>
                                    <a
                                        className="dropdown-item"
                                        href={url('stories.quiz.csv', {
                                            story: story.id,
                                        })}
                                    >
                                        <FormattedMessage
                                            defaultMessage="Quiz/Survey"
                                            description="Button label"
                                        />
                                    </a>
                                </li>
                                <li>
                                    <a
                                        className="dropdown-item"
                                        href={url('stories.contributions.csv', {
                                            story: story.id,
                                        })}
                                    >
                                        <FormattedMessage
                                            defaultMessage="Contributions"
                                            description="Button label"
                                        />
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <Button
                            href={url('stories.settings', {
                                story: story.id,
                            })}
                            theme="secondary"
                            outline
                            className="me-2 mb-2"
                            icon={<FontAwesomeIcon icon={faCog} color="currentColor" />}
                        >
                            <FormattedMessage
                                defaultMessage="Settings"
                                description="Settings Button label"
                            />
                        </Button>
                        <AddButton
                            href={`${url('stories.editor', {
                                story: story ? story.id : null,
                            })}?create=1`}
                            className="me-2 mb-2"
                        >
                            <FormattedMessage
                                defaultMessage="New screen"
                                description="New screen Button label"
                            />
                        </AddButton>
                    </div>
                </div>
            </div>
        </div>
    );
};

StoryMenubar.propTypes = propTypes;
StoryMenubar.defaultProps = defaultProps;

export default StoryMenubar;
